/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown> }} Wrapped_Period_Strength_BestInputs */

const en_us2_wrapped_period_strength_best = /** @type {(inputs: Wrapped_Period_Strength_BestInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Your best estimated max strength of the month.`);
	return /** @type {LocalizedString} */ (`Your best estimated max strength of the year.`)
	
};

const pt_br2_wrapped_period_strength_best = /** @type {(inputs: Wrapped_Period_Strength_BestInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Sua melhor força máxima estimada do mês.`);
	return /** @type {LocalizedString} */ (`Sua melhor força máxima estimada do ano.`)
	
};

const es_419_wrapped_period_strength_best = /** @type {(inputs: Wrapped_Period_Strength_BestInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Tu mejor fuerza máxima estimada del mes.`);
	return /** @type {LocalizedString} */ (`Tu mejor fuerza máxima estimada del año.`)
	
};

const pt_pt2_wrapped_period_strength_best = /** @type {(inputs: Wrapped_Period_Strength_BestInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`A tua melhor força máxima estimada do mês.`);
	return /** @type {LocalizedString} */ (`A tua melhor força máxima estimada do ano.`)
	
};

const fr_fr2_wrapped_period_strength_best = /** @type {(inputs: Wrapped_Period_Strength_BestInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Ta meilleure force max estimée du mois.`);
	return /** @type {LocalizedString} */ (`Ta meilleure force max estimée de l'année.`)
	
};

const de_de2_wrapped_period_strength_best = /** @type {(inputs: Wrapped_Period_Strength_BestInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Deine beste geschätzte Maximalkraft des Monats.`);
	return /** @type {LocalizedString} */ (`Deine beste geschätzte Maximalkraft des Jahres.`)
	
};

const it_it2_wrapped_period_strength_best = /** @type {(inputs: Wrapped_Period_Strength_BestInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`La tua migliore forza massima stimata del mese.`);
	return /** @type {LocalizedString} */ (`La tua migliore forza massima stimata dell'anno.`)
	
};

/**
* | period | output |
* | --- | --- |
* | "month" | "Your best estimated max strength of the month." |
* | * | "Your best estimated max strength of the year." |
*
* @param {Wrapped_Period_Strength_BestInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_period_strength_best = /** @type {((inputs: Wrapped_Period_Strength_BestInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Period_Strength_BestInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_period_strength_best(inputs)
	if (locale === "es-419") return es_419_wrapped_period_strength_best(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_period_strength_best(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_period_strength_best(inputs)
	if (locale === "de-DE") return de_de2_wrapped_period_strength_best(inputs)
	if (locale === "it-IT") return it_it2_wrapped_period_strength_best(inputs)
	return en_us2_wrapped_period_strength_best(inputs)
});
export { wrapped_period_strength_best as "wrapped-period.strength_best" }